import { useAutoRoutingUK } from '../../../hooks/useAutoRouting/useAutoRoutingUK';

type TProps = {
  children?: React.ReactNode;
};

const StepRouterUK = ({ children }: TProps) => {
  useAutoRoutingUK();

  return <>{children}</>;
};

export default StepRouterUK;
